import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-multi-select-dropdown',
  standalone: false,
  templateUrl: './multi-select-dropdown.component.html',
  styleUrl: './multi-select-dropdown.component.scss',
})
export class MultiSelectDropdownComponent {
  @Input() options: { value: string; key: string }[] = [];
  @Input() placeholder: string = 'Select options';
  @Output() selectionChange = new EventEmitter<string[]>();

  isOpen = false;
  selectedValues: string[] = [];

  toggleDropdown() {
    this.isOpen = !this.isOpen;
  }

  isSelected(value: string): boolean {
    return this.selectedValues.includes(value);
  }

  toggleSelection(value: string) {
    if (this.isSelected(value)) {
      this.selectedValues = this.selectedValues.filter(v => v !== value);
    } else {
      this.selectedValues.push(value);
    }
    this.selectionChange.emit(this.selectedValues);
  }
}
